export class Location {
  public address: string;
  public details: string;
  public latitude: number;
  public longitude: number;
}
